import {Injectable} from '@angular/core';
import {CustomHttp} from '../customhttp';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {ModelModel} from '../model/spring-model/model.model';
import {AppConstants} from '../app.constants';
import {IndexPanelModel} from '../model/spring-model/indexPanel.model';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class PanelIndexService {

  constructor(public http: CustomHttp, private https: HttpClient, private  authService: AuthenticationService) {
  }
  getPanelIndex(): Observable<HttpResponse<IndexPanelModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'indexPanel' ;
    return this.https.get<IndexPanelModel>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/panelIndex.service.ts